import React from 'react';
import { techItems } from '../../data/marquee';
import './TechMarquee.css';

const TechMarquee: React.FC = () => {
  const doubled = [...techItems, ...techItems];
  return (
    <div className="tech-strip">
      <div className="marquee-track">
        {doubled.map((item, i) => (
          <span className="marquee-item" key={i}>{item.label}</span>
        ))}
      </div>
    </div>
  );
};

export default TechMarquee;